import { z } from 'zod/v4';
import { PaymentType, State } from '../../economy/case-vouchers/index.js';
import { VoucherCategory } from '../../economy/vouchers/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { propertyItemSchema } from './property-shape.js';
const inputSchema = z.object({
    voucherId: z
        .uuid()
        .describe('The voucher to fetch. Obtain via search_vouchers — do not invent ids.'),
});
const outputSchema = z.object({
    voucherId: z.uuid(),
    referenceId: z.string().nullable(),
    label: z.string(),
    category: z.enum(VoucherCategory),
    amount: z
        .string()
        .describe('Decimal amount in the case currency that counts toward the balance: what is left of the voucher after write-offs. Debt is negative, payments positive.'),
    originalAmount: z
        .string()
        .nullable()
        .describe('Decimal amount as originally entered, before anything was written off. Null for calculated interest, which has no amount of its own.'),
    writtenOffAmount: z
        .string()
        .describe('Decimal amount written off because the voucher expired or became irrecoverable, as a positive number. 0 when nothing was written off.'),
    transactedAt: z.iso.datetime().nullable(),
    dueDate: z.iso.date().nullable(),
    isPrincipal: z.boolean(),
    referenceVoucherId: z.uuid().nullable(),
    state: z.enum(State),
    expired: z
        .boolean()
        .describe('Marked expired (time-barred). Only what was unpaid of it is written off; what was paid stays paid.'),
    irrecoverableDate: z.iso
        .date()
        .nullable()
        .describe('Date from which what is unpaid of the voucher is written off as irrecoverable.'),
    interestType: z.string().nullable(),
    interestRatePct: z.number().nullable(),
    interestFromDate: z.iso.date().nullable(),
    paymentType: z.enum(PaymentType).nullable(),
    properties: z.array(propertyItemSchema),
});
export const getVoucherTool = {
    name: ToolName.GetVoucher,
    category: ToolCategory.Vouchers,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Read full details of a single voucher: label, category, amount (what counts now), original amount and what was written off, expiry, state, due date, reference voucher (for interest etc.), interest configuration, and payment type for payment vouchers. To understand the total still owed on the case, sum amounts via search_vouchers — the ledger sums to the outstanding balance. Expiry, write-offs and original amounts are internal: never mention them to the debtor, who is only told what they owe (amount).',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-voucher.js.map